import { forwardRef, HTMLAttributes, memo, ReactNode } from "react";
import classnames from "classnames";

import styles from "./styles.module.scss";

export type ModalHeaderAlign = "left" | "center" | "horizontalLeft"

export type ModalHeaderProps = HTMLAttributes<HTMLDivElement> & {
  text?: ReactNode
  divider?: boolean
  paddingBottom?: boolean
  align?: ModalHeaderAlign
  textClassName?: string
  supportingText?: ReactNode
  wrapperTitleClassName?: string
  supportingTextClassName?: string
}

export const ModalHeader = memo(forwardRef<HTMLDivElement, ModalHeaderProps>((
  {
    text,
    divider,
    paddingBottom,
    children,
    className,
    align,
    textClassName,
    supportingText,
    wrapperTitleClassName,
    supportingTextClassName,
    ...props
  }, ref) => {
  return (
    <div
      className={classnames(
        styles.root,
        className,
        styles[align as keyof typeof styles],
        {
          [styles.withoutChildren]: !!children,
          [styles.divider]: divider,
          [styles.paddingBottom]: paddingBottom,
        })}
      {...props}
      ref={ref}
    >
      {children}
      <div key="title" className={classnames(styles.wrapperTitle, wrapperTitleClassName)}>
        {text && <h4 key="text" className={classnames(styles.text, textClassName)}>{text}</h4>}
        {supportingText && <div key="supportingText" className={classnames(styles.supportingText, supportingTextClassName)}>{supportingText}</div>}
      </div>
    </div>
  );
}));